export class PricingStats {
    constructor(
        public currency: string,
        public firstSeenDate?: Date,
        public firstSeenPrice?: number,
        public lastSeenDate?: Date,
        public lastSeenPrice?: number
    ) { }
}